// Fichier généré par scripts/fetch-person-portraits.ts.
// Portraits issus de Wikipédia/Wikimedia Commons et soumis aux licences indiquées.

export interface PersonPortraitCredit {
  path: string;
  wikipediaTitle: string;
  wikipediaUrl: string;
  wikidataId: string;
  commonsFile: string;
  sourceUrl: string;
  author: string;
  license: string;
  licenseUrl?: string;
  retrievedAt: string;
}

export const personPortraits: Record<string, PersonPortraitCredit> = {
  "person-jean-jaures": {
    "path": "/images/persons/person-jean-jaures.jpg",
    "wikipediaTitle": "Jean Jaurès",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Jean_Jaur%C3%A8s",
    "wikidataId": "Q12688",
    "commonsFile": "Jean Jaurès, 1904, par Nadar.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Jean_Jaur%C3%A8s,_1904,_par_Nadar.jpg",
    "author": "Nadar",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-leon-blum": {
    "path": "/images/persons/person-leon-blum.jpg",
    "wikipediaTitle": "Léon Blum",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/L%C3%A9on_Blum",
    "wikidataId": "Q18434",
    "commonsFile": "Léon Blum Meurisse b 1927.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:L%C3%A9on_Blum_Meurisse_b_1927.jpg",
    "author": "Agence de presse Meurisse",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-maurice-thorez": {
    "path": "/images/persons/person-maurice-thorez.jpg",
    "wikipediaTitle": "Maurice Thorez",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Maurice_Thorez",
    "wikidataId": "Q345408",
    "commonsFile": "Maurice Thorez - VIIIe Congrès national du PCF.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Maurice_Thorez_-_VIIIe_Congr%C3%A8s_national_du_PCF.jpg",
    "author": "Unknown authorUnknown author",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-charles-de-gaulle": {
    "path": "/images/persons/person-charles-de-gaulle.jpg",
    "wikipediaTitle": "Charles de Gaulle",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Charles_de_Gaulle",
    "wikidataId": "Q2042",
    "commonsFile": "General Charles de Gaulle in 1945.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:General_Charles_de_Gaulle_in_1945.jpg",
    "author": "The National Archives UK",
    "license": "No restrictions",
    "licenseUrl": "https://www.flickr.com/commons/usage/",
    "retrievedAt": "2026-08-26"
  },
  "person-jules-guesde": {
    "path": "/images/persons/person-jules-guesde.jpg",
    "wikipediaTitle": "Jules Guesde",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Jules_Guesde",
    "wikidataId": "Q379699",
    "commonsFile": "Jules Guesde.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Jules_Guesde.jpg",
    "author": "Nazal?",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-paul-lafargue": {
    "path": "/images/persons/person-paul-lafargue.jpg",
    "wikipediaTitle": "Paul Lafargue",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Paul_Lafargue",
    "wikidataId": "Q317152",
    "commonsFile": "Paul Lafargue 1869.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Paul_Lafargue_1869.jpg",
    "author": "German Fehrenbach",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-aristide-briand": {
    "path": "/images/persons/person-aristide-briand.jpg",
    "wikipediaTitle": "Aristide Briand",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Aristide_Briand",
    "wikidataId": "Q179888",
    "commonsFile": "Aristide Briand 2.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Aristide_Briand_2.jpg",
    "author": "Henri Manuel",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-joseph-paul-boncour": {
    "path": "/images/persons/person-joseph-paul-boncour.jpg",
    "wikipediaTitle": "Joseph Paul-Boncour",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Joseph_Paul-Boncour",
    "wikidataId": "Q285865",
    "commonsFile": "Joseph Paul-Boncour 1923.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Joseph_Paul-Boncour_1923.jpg",
    "author": "Agence de presse Meurisse",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-rene-viviani": {
    "path": "/images/persons/person-rene-viviani.jpg",
    "wikipediaTitle": "René Viviani",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Ren%C3%A9_Viviani",
    "wikidataId": "Q431074",
    "commonsFile": "René Viviani.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Ren%C3%A9_Viviani.jpg",
    "author": "Agence de presse Meurisse",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-jacques-piou": {
    "path": "/images/persons/person-jacques-piou.jpg",
    "wikipediaTitle": "Jacques Piou",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Jacques_Piou",
    "wikidataId": "Q3159775",
    "commonsFile": "Jacques Piou (Agence Meurisse, 1913) (cropped and adjusted).jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Jacques_Piou_(Agence_Meurisse,_1913)_(cropped_and_adjusted).jpg",
    "author": "Agence de presse Meurisse",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-albert-de-mun": {
    "path": "/images/persons/person-albert-de-mun.jpg",
    "wikipediaTitle": "Albert de Mun",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Albert_de_Mun",
    "wikidataId": "Q2475967",
    "commonsFile": "Albert de Mun by Isidore Alphonse Chalot.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Albert_de_Mun_by_Isidore_Alphonse_Chalot.jpg",
    "author": "[Isidore Alphonse] Chalot, Paris",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-eugene-motte": {
    "path": "/images/persons/person-eugene-motte.png",
    "wikipediaTitle": "Eugène Motte (homme politique, 1860-1932)",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Eug%C3%A8ne_Motte_(homme_politique%2C_1860-1932)",
    "wikidataId": "Q3060053",
    "commonsFile": "Motte-Duthoit, Eugène.png",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Motte-Duthoit,_Eug%C3%A8ne.png",
    "author": "Unknown authorUnknown author",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-henri-vaugeois": {
    "path": "/images/persons/person-henri-vaugeois.jpg",
    "wikipediaTitle": "Henri Vaugeois",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Henri_Vaugeois",
    "wikidataId": "Q1082853",
    "commonsFile": "Vaugeois, Henri.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Vaugeois,_Henri.jpg",
    "author": "Maurice Joron (1883-1937)",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-maurice-pujo": {
    "path": "/images/persons/person-maurice-pujo.jpg",
    "wikipediaTitle": "Maurice Pujo",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Maurice_Pujo",
    "wikidataId": "Q610664",
    "commonsFile": "Maurice Pujo.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Maurice_Pujo.jpg",
    "author": "Agence de presse Meurisse",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-charles-maurras": {
    "path": "/images/persons/person-charles-maurras.jpg",
    "wikipediaTitle": "Charles Maurras",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Charles_Maurras",
    "wikidataId": "Q3048",
    "commonsFile": "Charles Maurras, photo Studio Harcourt, 1937.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Charles_Maurras,_photo_Studio_Harcourt,_1937.jpg",
    "author": "Studio Harcourt",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-paul-deroulede": {
    "path": "/images/persons/person-paul-deroulede.jpg",
    "wikipediaTitle": "Paul Déroulède",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Paul_D%C3%A9roul%C3%A8de",
    "wikidataId": "Q1094964",
    "commonsFile": "PaulDeroulede.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:PaulDeroulede.jpg",
    "author": "AnonymousUnknown author",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-pierre-taittinger": {
    "path": "/images/persons/person-pierre-taittinger.jpg",
    "wikipediaTitle": "Pierre Taittinger",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Pierre_Taittinger",
    "wikidataId": "Q3387066",
    "commonsFile": "Pierre Taittinger.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Pierre_Taittinger.jpg",
    "author": "Agence Meurisse (domaine public, voir notice détaillée)",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-ludovic-oscar-frossard": {
    "path": "/images/persons/person-ludovic-oscar-frossard.jpg",
    "wikipediaTitle": "Ludovic-Oscar Frossard",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Ludovic-Oscar_Frossard",
    "wikidataId": "Q1109027",
    "commonsFile": "Frossard-1929.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Frossard-1929.jpg",
    "author": "Agence Meurisse (domaine public, voir fiche détaillée Gallica)",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-marcel-cachin": {
    "path": "/images/persons/person-marcel-cachin.jpg",
    "wikipediaTitle": "Marcel Cachin",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Marcel_Cachin",
    "wikidataId": "Q658479",
    "commonsFile": "Marcel Cachin b Meurisse 1918.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Marcel_Cachin_b_Meurisse_1918.jpg",
    "author": "Agence de presse Meurisse",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-edouard-herriot": {
    "path": "/images/persons/person-edouard-herriot.jpg",
    "wikipediaTitle": "Édouard Herriot",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/%C3%89douard_Herriot",
    "wikidataId": "Q274344",
    "commonsFile": "Édouard Herriot - Président du Conseil - 1924.jpeg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:%C3%89douard_Herriot_-_Pr%C3%A9sident_du_Conseil_-_1924.jpeg",
    "author": "Agence de presse Meurisse",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-raymond-poincare": {
    "path": "/images/persons/person-raymond-poincare.jpg",
    "wikipediaTitle": "Raymond Poincaré",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Raymond_Poincar%C3%A9",
    "wikidataId": "Q191974",
    "commonsFile": "Raymond Poincaré 1914.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Raymond_Poincar%C3%A9_1914.jpg",
    "author": "Harris & Ewing",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-alexandre-millerand": {
    "path": "/images/persons/person-alexandre-millerand.jpg",
    "wikipediaTitle": "Alexandre Millerand",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Alexandre_Millerand",
    "wikidataId": "Q274540",
    "commonsFile": "Alexandre Millerand (cropped).jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Alexandre_Millerand_(cropped).jpg",
    "author": "Unknown authorUnknown author",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-louis-marin": {
    "path": "/images/persons/person-louis-marin.jpg",
    "wikipediaTitle": "Louis Marin (homme politique)",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Louis_Marin_(homme_politique)",
    "wikidataId": "Q1229977",
    "commonsFile": "Louis Marin.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Louis_Marin.jpg",
    "author": "Unknown authorUnknown author",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-georges-mandel": {
    "path": "/images/persons/person-georges-mandel.jpg",
    "wikipediaTitle": "Georges Mandel",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Georges_Mandel",
    "wikidataId": "Q669893",
    "commonsFile": "Georges Mandel.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Georges_Mandel.jpg",
    "author": "AnonymousUnknown author (Keystone-France)",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-marc-sangnier": {
    "path": "/images/persons/person-marc-sangnier.jpg",
    "wikipediaTitle": "Marc Sangnier",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Marc_Sangnier",
    "wikidataId": "Q1248451",
    "commonsFile": "Marc Sangnier (Agence Rol, 1919) 1.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Marc_Sangnier_(Agence_Rol,_1919)_1.jpg",
    "author": "Agence Rol",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-georges-valois": {
    "path": "/images/persons/person-georges-valois.jpg",
    "wikipediaTitle": "Georges Valois",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Georges_Valois",
    "wikidataId": "Q545580",
    "commonsFile": "Valois (Boissonas).jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Valois_(Boissonas).jpg",
    "author": "Frédéric Boissonnas",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-eugene-deloncle": {
    "path": "/images/persons/person-eugene-deloncle.jpg",
    "wikipediaTitle": "Eugène Deloncle",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Eug%C3%A8ne_Deloncle",
    "wikidataId": "Q544548",
    "commonsFile": "Eugène Deloncle vers 1940.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Eug%C3%A8ne_Deloncle_vers_1940.jpg",
    "author": "Unknown authorUnknown author",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-marcel-deat": {
    "path": "/images/persons/person-marcel-deat.jpg",
    "wikipediaTitle": "Marcel Déat",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Marcel_D%C3%A9at",
    "wikidataId": "Q686084",
    "commonsFile": "Marcel Déat-1932.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Marcel_D%C3%A9at-1932.jpg",
    "author": "Agence Meurisse (domaine public, voir fiche détaillée Gallica)",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-adrien-marquet": {
    "path": "/images/persons/person-adrien-marquet.jpg",
    "wikipediaTitle": "Adrien Marquet",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Adrien_Marquet",
    "wikidataId": "Q2825221",
    "commonsFile": "Adrien Marquet 1933.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Adrien_Marquet_1933.jpg",
    "author": "Agence de presse Mondial Photo-Presse",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-paul-ramadier": {
    "path": "/images/persons/person-paul-ramadier.jpg",
    "wikipediaTitle": "Paul Ramadier",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Paul_Ramadier",
    "wikidataId": "Q328235",
    "commonsFile": "Paul Ramadier.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Paul_Ramadier.jpg",
    "author": "Agence de presse Meurisse",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-marceau-pivert": {
    "path": "/images/persons/person-marceau-pivert.jpg",
    "wikipediaTitle": "Marceau Pivert",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Marceau_Pivert",
    "wikidataId": "Q1370034",
    "commonsFile": "Marceau Pivert 1932.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Marceau_Pivert_1932.jpg",
    "author": "Agence de presse Meurisse",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-vincent-auriol": {
    "path": "/images/persons/person-vincent-auriol.png",
    "wikipediaTitle": "Vincent Auriol",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Vincent_Auriol",
    "wikidataId": "Q158772",
    "commonsFile": "VincentAuriol (cropped).png",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:VincentAuriol_(cropped).png",
    "author": "Abbie Rowe",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-jean-zyromski": {
    "path": "/images/persons/person-jean-zyromski.jpg",
    "wikipediaTitle": "Jean Zyromski",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Jean_Zyromski",
    "wikidataId": "Q3175146",
    "commonsFile": "Zyromski membre de la C.A.P.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Zyromski_membre_de_la_C.A.P.jpg",
    "author": "Agence de presse Meurisse",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-edouard-daladier": {
    "path": "/images/persons/person-edouard-daladier.jpg",
    "wikipediaTitle": "Édouard Daladier",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/%C3%89douard_Daladier",
    "wikidataId": "Q213526",
    "commonsFile": "Édouard Daladier.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:%C3%89douard_Daladier.jpg",
    "author": "Henri Manuel",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-pierre-etienne-flandin": {
    "path": "/images/persons/person-pierre-etienne-flandin.jpg",
    "wikipediaTitle": "Pierre-Étienne Flandin",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Pierre-%C3%89tienne_Flandin",
    "wikidataId": "Q471296",
    "commonsFile": "Pierre-Étienne Flandin 1931.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Pierre-%C3%89tienne_Flandin_1931.jpg",
    "author": "Georges Devred",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-francois-de-la-rocque": {
    "path": "/images/persons/person-francois-de-la-rocque.jpg",
    "wikipediaTitle": "François de La Rocque",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Fran%C3%A7ois_de_La_Rocque",
    "wikidataId": "Q1339879",
    "commonsFile": "La Rocque - photographie de Boissonnas.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:La_Rocque_-_photographie_de_Boissonnas.jpg",
    "author": "Frédéric Boissonnas / André Taponier",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-jacques-doriot": {
    "path": "/images/persons/person-jacques-doriot.jpg",
    "wikipediaTitle": "Jacques Doriot",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Jacques_Doriot",
    "wikidataId": "Q724729",
    "commonsFile": "Jacques Doriot.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Jacques_Doriot.jpg",
    "author": "Agence de presse Meurisse",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-leon-daudet": {
    "path": "/images/persons/person-leon-daudet.jpg",
    "wikipediaTitle": "Léon Daudet",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/L%C3%A9on_Daudet",
    "wikidataId": "Q92562",
    "commonsFile": "Léon Daudet par Paul Nadar.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:L%C3%A9on_Daudet_par_Paul_Nadar.jpg",
    "author": "Paul Nadar",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-marcel-bucard": {
    "path": "/images/persons/person-marcel-bucard.jpg",
    "wikipediaTitle": "Marcel Bucard",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Marcel_Bucard",
    "wikidataId": "Q468019",
    "commonsFile": "Bucard, Marcel.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Bucard,_Marcel.jpg",
    "author": "Agence de presse Meurisse",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-pierre-costantini": {
    "path": "/images/persons/person-pierre-costantini.jpg",
    "wikipediaTitle": "Pierre Costantini",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Pierre_Costantini",
    "wikidataId": "Q1879426",
    "commonsFile": "Costantini, Pierre.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Costantini,_Pierre.jpg",
    "author": "Unknown authorUnknown author",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-philippe-petain": {
    "path": "/images/persons/person-philippe-petain.jpg",
    "wikipediaTitle": "Philippe Pétain",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Philippe_P%C3%A9tain",
    "wikidataId": "Q5721",
    "commonsFile": "Pétain - portrait photographique.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:P%C3%A9tain_-_portrait_photographique.jpg",
    "author": "Imprimerie Draeger à Montrouge en région parisienne",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-paul-reynaud": {
    "path": "/images/persons/person-paul-reynaud.jpg",
    "wikipediaTitle": "Paul Reynaud",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Paul_Reynaud",
    "wikidataId": "Q161076",
    "commonsFile": "Paul Reynaud 1940.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Paul_Reynaud_1940.jpg",
    "author": "AnonymousUnknown author",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-guy-mollet": {
    "path": "/images/persons/person-guy-mollet.jpg",
    "wikipediaTitle": "Guy Mollet",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Guy_Mollet",
    "wikidataId": "Q314006",
    "commonsFile": "Guy Mollet 1956.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Guy_Mollet_1956.jpg",
    "author": "Photographe anonyme, Anefo",
    "license": "CC0",
    "licenseUrl": "http://creativecommons.org/publicdomain/zero/1.0/deed.en",
    "retrievedAt": "2026-08-26"
  },
  "person-pierre-mendes-france": {
    "path": "/images/persons/person-pierre-mendes-france.jpg",
    "wikipediaTitle": "Pierre Mendès France",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Pierre_Mend%C3%A8s_France",
    "wikidataId": "Q314265",
    "commonsFile": "Pierre Mendès-France 1932.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Pierre_Mend%C3%A8s-France_1932.jpg",
    "author": "Agence de presse Mondial Photo-Presse",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-felix-gaillard": {
    "path": "/images/persons/person-felix-gaillard.jpg",
    "wikipediaTitle": "Félix Gaillard",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/F%C3%A9lix_Gaillard",
    "wikidataId": "Q365413",
    "commonsFile": "Félix Gaillard en 1952.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:F%C3%A9lix_Gaillard_en_1952.jpg",
    "author": "AnonymousUnknown author (Keystone France)",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-georges-bidault": {
    "path": "/images/persons/person-georges-bidault.jpg",
    "wikipediaTitle": "Georges Bidault",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Georges_Bidault",
    "wikidataId": "Q312026",
    "commonsFile": "Georges Bidault.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Georges_Bidault.jpg",
    "author": "Unknown authorUnknown author",
    "license": "CC BY-SA 3.0 nl",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/nl/deed.en",
    "retrievedAt": "2026-08-26"
  },
  "person-robert-schuman": {
    "path": "/images/persons/person-robert-schuman.jpg",
    "wikipediaTitle": "Robert Schuman",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Robert_Schuman",
    "wikidataId": "Q15981",
    "commonsFile": "Robert Schuman 1958.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Robert_Schuman_1958.jpg",
    "author": "European Commission",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0",
    "retrievedAt": "2026-08-26"
  },
  "person-pierre-pflimlin": {
    "path": "/images/persons/person-pierre-pflimlin.jpg",
    "wikipediaTitle": "Pierre Pflimlin",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Pierre_Pflimlin",
    "wikidataId": "Q328504",
    "commonsFile": "Pierre Pflimlin par Claude Truong-Ngoc 1975.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Pierre_Pflimlin_par_Claude_Truong-Ngoc_1975.jpg",
    "author": "Photo Claude TRUONG-NGOC",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "retrievedAt": "2026-08-26"
  },
  "person-rene-pleven": {
    "path": "/images/persons/person-rene-pleven.jpg",
    "wikipediaTitle": "René Pleven",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Ren%C3%A9_Pleven",
    "wikidataId": "Q314545",
    "commonsFile": "René Pleven.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Ren%C3%A9_Pleven.jpg",
    "author": "AnonymousUnknown author (Keystone France)",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-francois-mitterrand": {
    "path": "/images/persons/person-francois-mitterrand.jpg",
    "wikipediaTitle": "François Mitterrand",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Fran%C3%A7ois_Mitterrand",
    "wikidataId": "Q2038",
    "commonsFile": "President François Mitterrand in 1983.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:President_Fran%C3%A7ois_Mitterrand_in_1983.jpg",
    "author": "Comet Photo AG (Zürich)",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "retrievedAt": "2026-08-26"
  },
  "person-jacques-soustelle": {
    "path": "/images/persons/person-jacques-soustelle.jpg",
    "wikipediaTitle": "Jacques Soustelle",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Jacques_Soustelle",
    "wikidataId": "Q699510",
    "commonsFile": "Jacques Soustelle, Bestanddeelnr 909-5719 (cropped).jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Jacques_Soustelle,_Bestanddeelnr_909-5719_(cropped).jpg",
    "author": "Anefo",
    "license": "CC0",
    "licenseUrl": "http://creativecommons.org/publicdomain/zero/1.0/deed.en",
    "retrievedAt": "2026-08-26"
  },
  "person-andre-malraux": {
    "path": "/images/persons/person-andre-malraux.jpg",
    "wikipediaTitle": "André Malraux",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Andr%C3%A9_Malraux",
    "wikidataId": "Q151164",
    "commonsFile": "André Malraux, Pic, 22.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Andr%C3%A9_Malraux,_Pic,_22.jpg",
    "author": "Roger Pic",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-jacques-chaban-delmas": {
    "path": "/images/persons/person-jacques-chaban-delmas.jpg",
    "wikipediaTitle": "Jacques Chaban-Delmas",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Jacques_Chaban-Delmas",
    "wikidataId": "Q12940",
    "commonsFile": "EEG-conferentie Den Haag Jacques Chaban-Delmas (cropped).jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:EEG-conferentie_Den_Haag_Jacques_Chaban-Delmas_(cropped).jpg",
    "author": "Eric Koch for Anefo",
    "license": "CC0",
    "licenseUrl": "http://creativecommons.org/publicdomain/zero/1.0/deed.en",
    "retrievedAt": "2026-08-26"
  },
  "person-georges-pompidou": {
    "path": "/images/persons/person-georges-pompidou.jpg",
    "wikipediaTitle": "Georges Pompidou",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Georges_Pompidou",
    "wikidataId": "Q2185",
    "commonsFile": "Georges Pompidou 1969 (cropped).jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Georges_Pompidou_1969_(cropped).jpg",
    "author": "Farabola",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-roger-duchet": {
    "path": "/images/persons/person-roger-duchet.jpg",
    "wikipediaTitle": "Roger Duchet",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Roger_Duchet",
    "wikidataId": "Q3438910",
    "commonsFile": "Roger Duchet.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Roger_Duchet.jpg",
    "author": "AnonymousUnknown author (Keystone France)",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-antoine-pinay": {
    "path": "/images/persons/person-antoine-pinay.jpg",
    "wikipediaTitle": "Antoine Pinay",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Antoine_Pinay",
    "wikidataId": "Q356724",
    "commonsFile": "Antoine Pinay 1969.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Antoine_Pinay_1969.jpg",
    "author": "Farabola",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-valery-giscard-destaing": {
    "path": "/images/persons/person-valery-giscard-destaing.jpg",
    "wikipediaTitle": "Valéry Giscard d'Estaing",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Val%C3%A9ry_Giscard_d'Estaing",
    "wikidataId": "Q2124",
    "commonsFile": "Valéry Giscard d'Estaing (1975).jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Val%C3%A9ry_Giscard_d%27Estaing_(1975).jpg",
    "author": "Christian Lambiotte",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0",
    "retrievedAt": "2026-08-26"
  },
  "person-michel-clemenceau": {
    "path": "/images/persons/person-michel-clemenceau.jpg",
    "wikipediaTitle": "Michel Clemenceau",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Michel_Clemenceau",
    "wikidataId": "Q2189394",
    "commonsFile": "Michel Clemenceau.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Michel_Clemenceau.jpg",
    "author": "Agence de presse Meurisse",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-pierre-de-gaulle": {
    "path": "/images/persons/person-pierre-de-gaulle.jpg",
    "wikipediaTitle": "Pierre de Gaulle",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Pierre_de_Gaulle",
    "wikidataId": "Q3387553",
    "commonsFile": "Pierre De Gaulle et la reine Juliana 1950.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Pierre_De_Gaulle_et_la_reine_Juliana_1950.jpg",
    "author": "Daan Noske / Anefo",
    "license": "CC0",
    "licenseUrl": "http://creativecommons.org/publicdomain/zero/1.0/deed.en",
    "retrievedAt": "2026-08-26"
  },
  "person-edouard-depreux": {
    "path": "/images/persons/person-edouard-depreux.jpg",
    "wikipediaTitle": "Édouard Depreux",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/%C3%89douard_Depreux",
    "wikidataId": "Q3579808",
    "commonsFile": "Édouard Depreux 1946.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:%C3%89douard_Depreux_1946.jpg",
    "author": "AnonymousUnknown author (Keystone France)",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-alain-savary": {
    "path": "/images/persons/person-alain-savary.jpg",
    "wikipediaTitle": "Alain Savary",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Alain_Savary",
    "wikidataId": "Q477121",
    "commonsFile": "Alain Savary - Hôtel de Ville de Ksar-Hellal - Tunisie.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Alain_Savary_-_H%C3%B4tel_de_Ville_de_Ksar-Hellal_-_Tunisie.jpg",
    "author": "Natma 2",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "retrievedAt": "2026-08-26"
  },
  "person-pierre-frank": {
    "path": "/images/persons/person-pierre-frank.jpg",
    "wikipediaTitle": "Pierre Frank",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Pierre_Frank",
    "wikidataId": "Q2702738",
    "commonsFile": "PierreFrank.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:PierreFrank.jpg",
    "author": "Unknown authorUnknown author",
    "license": "CC BY-SA 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/2.0",
    "retrievedAt": "2026-08-26"
  },
  "person-pierre-lagaillarde": {
    "path": "/images/persons/person-pierre-lagaillarde.jpg",
    "wikipediaTitle": "Pierre Lagaillarde",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Pierre_Lagaillarde",
    "wikidataId": "Q713316",
    "commonsFile": "Pierre Lagaillarde (1961).jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Pierre_Lagaillarde_(1961).jpg",
    "author": "Fotograaf Onbekend / Anefo",
    "license": "CC0",
    "licenseUrl": "http://creativecommons.org/publicdomain/zero/1.0/deed.en",
    "retrievedAt": "2026-08-26"
  },
  "person-raoul-salan": {
    "path": "/images/persons/person-raoul-salan.jpg",
    "wikipediaTitle": "Raoul Salan",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Raoul_Salan",
    "wikidataId": "Q241944",
    "commonsFile": "Generaal Salan, Bestanddeelnr 909-5643.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Generaal_Salan,_Bestanddeelnr_909-5643.jpg",
    "author": "Anefo",
    "license": "CC0",
    "licenseUrl": "http://creativecommons.org/publicdomain/zero/1.0/deed.en",
    "retrievedAt": "2026-08-26"
  },
  "person-waldeck-rochet": {
    "path": "/images/persons/person-waldeck-rochet.jpg",
    "wikipediaTitle": "Waldeck Rochet",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Waldeck_Rochet",
    "wikidataId": "Q3565308",
    "commonsFile": "Waldeck Rochet 1968 (cropped).jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Waldeck_Rochet_1968_(cropped).jpg",
    "author": "Unknown authorUnknown author",
    "license": "CC BY-SA 3.0 nl",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/nl/deed.en",
    "retrievedAt": "2026-08-26"
  },
  "person-georges-marchais": {
    "path": "/images/persons/person-georges-marchais.jpg",
    "wikipediaTitle": "Georges Marchais",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Georges_Marchais",
    "wikidataId": "Q182192",
    "commonsFile": "Georges Marchais.JPG",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Georges_Marchais.JPG",
    "author": "David Boeno",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "retrievedAt": "2026-08-26"
  },
  "person-jacques-duclos": {
    "path": "/images/persons/person-jacques-duclos.jpg",
    "wikipediaTitle": "Jacques Duclos",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Jacques_Duclos",
    "wikidataId": "Q377790",
    "commonsFile": "Jacques Duclos en 1959.JPG",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Jacques_Duclos_en_1959.JPG",
    "author": "Sénat français",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "retrievedAt": "2026-08-26"
  },
  "person-alain-krivine": {
    "path": "/images/persons/person-alain-krivine.jpg",
    "wikipediaTitle": "Alain Krivine",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Alain_Krivine",
    "wikidataId": "Q12938",
    "commonsFile": "Alain Krivine 19-03-09 (cropped).jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Alain_Krivine_19-03-09_(cropped).jpg",
    "author": "Siren-Com",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "retrievedAt": "2026-08-26"
  },
  "person-daniel-cohn-bendit": {
    "path": "/images/persons/person-daniel-cohn-bendit.jpg",
    "wikipediaTitle": "Daniel Cohn-Bendit",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Daniel_Cohn-Bendit",
    "wikidataId": "Q76837",
    "commonsFile": "Europe Ecologie closing rally regional elections 2010-03-10 n14.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Europe_Ecologie_closing_rally_regional_elections_2010-03-10_n14.jpg",
    "author": "Marie-Lan Nguyen",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0",
    "retrievedAt": "2026-08-26"
  },
  "person-michel-rocard": {
    "path": "/images/persons/person-michel-rocard.jpg",
    "wikipediaTitle": "Michel Rocard",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Michel_Rocard",
    "wikidataId": "Q12946",
    "commonsFile": "Michel Rocard MEDEF (cropped).jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Michel_Rocard_MEDEF_(cropped).jpg",
    "author": "Olivier Ezratty",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "retrievedAt": "2026-08-26"
  },
  "person-gaston-defferre": {
    "path": "/images/persons/person-gaston-defferre.png",
    "wikipediaTitle": "Gaston Defferre",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Gaston_Defferre",
    "wikidataId": "Q608815",
    "commonsFile": "Defferre 1981 (cropped).png",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Defferre_1981_(cropped).png",
    "author": "[Service de l'information et des relations publiques du ministère de l'Intérieur]",
    "license": "CC0",
    "licenseUrl": "http://creativecommons.org/publicdomain/zero/1.0/deed.en",
    "retrievedAt": "2026-08-26"
  },
  "person-jean-jacques-servan-schreiber": {
    "path": "/images/persons/person-jean-jacques-servan-schreiber.jpg",
    "wikipediaTitle": "Jean-Jacques Servan-Schreiber",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Jean-Jacques_Servan-Schreiber",
    "wikidataId": "Q431565",
    "commonsFile": "Jean-Jacques Servan-Schreiber (1968).jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Jean-Jacques_Servan-Schreiber_(1968).jpg",
    "author": "Ron Kroon / Anefo",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "retrievedAt": "2026-08-26"
  },
  "person-jean-lecanuet": {
    "path": "/images/persons/person-jean-lecanuet.jpg",
    "wikipediaTitle": "Jean Lecanuet",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Jean_Lecanuet",
    "wikidataId": "Q537864",
    "commonsFile": "Lecanuet 1984.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Lecanuet_1984.jpg",
    "author": "European Parliament Multimedia Centre",
    "license": "Attribution",
    "retrievedAt": "2026-08-26"
  },
  "person-alain-poher": {
    "path": "/images/persons/person-alain-poher.jpg",
    "wikipediaTitle": "Alain Poher",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Alain_Poher",
    "wikidataId": "Q12950",
    "commonsFile": "Poher 1980s (cropped).jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Poher_1980s_(cropped).jpg",
    "author": "European Parliament",
    "license": "Attribution",
    "retrievedAt": "2026-08-26"
  },
  "person-roger-frey": {
    "path": "/images/persons/person-roger-frey.png",
    "wikipediaTitle": "Roger Frey",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Roger_Frey",
    "wikidataId": "Q926639",
    "commonsFile": "Portrait ministre de l'Intérieur Frey - Archives nationales (France).png",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Portrait_ministre_de_l%27Int%C3%A9rieur_Frey_-_Archives_nationales_(France).png",
    "author": "[Service de l'information et des relations publiques du ministère de l'Intérieur]",
    "license": "CC0",
    "licenseUrl": "http://creativecommons.org/publicdomain/zero/1.0/deed.en",
    "retrievedAt": "2026-08-26"
  },
  "person-michel-debre": {
    "path": "/images/persons/person-michel-debre.jpg",
    "wikipediaTitle": "Michel Debré",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Michel_Debr%C3%A9",
    "wikidataId": "Q296386",
    "commonsFile": "Michel Debré.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Michel_Debr%C3%A9.jpg",
    "author": "Ludwig Wegmann",
    "license": "CC BY-SA 3.0 de",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/de/deed.en",
    "retrievedAt": "2026-08-26"
  },
  "person-maurice-couve-de-murville": {
    "path": "/images/persons/person-maurice-couve-de-murville.jpg",
    "wikipediaTitle": "Maurice Couve de Murville",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Maurice_Couve_de_Murville",
    "wikidataId": "Q312034",
    "commonsFile": "MCDV 1967 (cropped).jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:MCDV_1967_(cropped).jpg",
    "author": "European Commission",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0",
    "retrievedAt": "2026-08-26"
  },
  "person-rene-dumont": {
    "path": "/images/persons/person-rene-dumont.png",
    "wikipediaTitle": "René Dumont",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Ren%C3%A9_Dumont",
    "wikidataId": "Q927879",
    "commonsFile": "René Dumont 1930-1940.png",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Ren%C3%A9_Dumont_1930-1940.png",
    "author": "Unknown authorUnknown author",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-jacques-chirac": {
    "path": "/images/persons/person-jacques-chirac.jpg",
    "wikipediaTitle": "Jacques Chirac",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Jacques_Chirac",
    "wikidataId": "Q2105",
    "commonsFile": "Jacques Chirac (1997) (cropped).jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Jacques_Chirac_(1997)_(cropped).jpg",
    "author": "Christian Lambiotte",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0",
    "retrievedAt": "2026-08-26"
  },
  "person-pierre-messmer": {
    "path": "/images/persons/person-pierre-messmer.jpg",
    "wikipediaTitle": "Pierre Messmer",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Pierre_Messmer",
    "wikidataId": "Q271822",
    "commonsFile": "Pierre Messmer01.JPG",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Pierre_Messmer01.JPG",
    "author": "Roland Godefroy",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0",
    "retrievedAt": "2026-08-26"
  },
  "person-raymond-barre": {
    "path": "/images/persons/person-raymond-barre.jpg",
    "wikipediaTitle": "Raymond Barre",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Raymond_Barre",
    "wikidataId": "Q12957",
    "commonsFile": "Raymond Barre 1991.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Raymond_Barre_1991.jpg",
    "author": "Bundesarchiv_B_145_Bild-F087872-0008,_Bonn,_Verleihung_Coudenhove-Kalergi-Preis_an_Kohl.jpg: Reineke, Engelbert derivative work: Ascaron (talk)",
    "license": "CC BY-SA 3.0 de",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/de/deed.en",
    "retrievedAt": "2026-08-26"
  },
  "person-michel-crepeau": {
    "path": "/images/persons/person-michel-crepeau.png",
    "wikipediaTitle": "Michel Crépeau",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Michel_Cr%C3%A9peau",
    "wikidataId": "Q348474",
    "commonsFile": "Michel Crépeau 1981 (cropped).png",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Michel_Cr%C3%A9peau_1981_(cropped).png",
    "author": "CEVIPOF Sciences Po",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "retrievedAt": "2026-08-26"
  },
  "person-lionel-jospin": {
    "path": "/images/persons/person-lionel-jospin.jpg",
    "wikipediaTitle": "Lionel Jospin",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Lionel_Jospin",
    "wikidataId": "Q187099",
    "commonsFile": "Lionel Jospin, Klaus Hänsch 1996 (cropped).jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Lionel_Jospin,_Klaus_H%C3%A4nsch_1996_(cropped).jpg",
    "author": "European Parliament",
    "license": "Attribution",
    "retrievedAt": "2026-08-26"
  },
  "person-jean-pierre-soisson": {
    "path": "/images/persons/person-jean-pierre-soisson.jpg",
    "wikipediaTitle": "Jean-Pierre Soisson",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Jean-Pierre_Soisson",
    "wikidataId": "Q603262",
    "commonsFile": "Jean-Pierre Soisson (cropped).jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Jean-Pierre_Soisson_(cropped).jpg",
    "author": "Gege089 at French Wikipedia",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-francois-leotard": {
    "path": "/images/persons/person-francois-leotard.jpg",
    "wikipediaTitle": "François Léotard",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Fran%C3%A7ois_L%C3%A9otard",
    "wikidataId": "Q1394083",
    "commonsFile": "Francés Leotard.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Franc%C3%A9s_Leotard.jpg",
    "author": "Annabelle deFC",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "retrievedAt": "2026-08-26"
  },
  "person-michel-poniatowski": {
    "path": "/images/persons/person-michel-poniatowski.jpg",
    "wikipediaTitle": "Michel Poniatowski",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Michel_Poniatowski",
    "wikidataId": "Q3310623",
    "commonsFile": "Michel Poniatowski MEP 1979.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Michel_Poniatowski_MEP_1979.jpg",
    "author": "European Parliament",
    "license": "Attribution",
    "retrievedAt": "2026-08-26"
  },
  "person-pierre-mehaignerie": {
    "path": "/images/persons/person-pierre-mehaignerie.jpg",
    "wikipediaTitle": "Pierre Méhaignerie",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Pierre_M%C3%A9haignerie",
    "wikidataId": "Q895873",
    "commonsFile": "Pierre Méhaignerie.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Pierre_M%C3%A9haignerie.jpg",
    "author": "Fpleclercq",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "retrievedAt": "2026-08-26"
  },
  "person-jean-pierre-fourcade": {
    "path": "/images/persons/person-jean-pierre-fourcade.jpg",
    "wikipediaTitle": "Jean-Pierre Fourcade",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Jean-Pierre_Fourcade",
    "wikidataId": "Q1685206",
    "commonsFile": "Jean-Pierre Fourcade.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Jean-Pierre_Fourcade.jpg",
    "author": "Olivier Ezratty",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "retrievedAt": "2026-08-26"
  },
  "person-jean-marie-le-pen": {
    "path": "/images/persons/person-jean-marie-le-pen.jpg",
    "wikipediaTitle": "Jean-Marie Le Pen",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Jean-Marie_Le_Pen",
    "wikidataId": "Q7177",
    "commonsFile": "Le Pen Jean-Marie 1999.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Le_Pen_Jean-Marie_1999.jpg",
    "author": "European Parliament Multimedia Centre",
    "license": "Attribution",
    "retrievedAt": "2026-08-26"
  },
  "person-arlette-laguiller": {
    "path": "/images/persons/person-arlette-laguiller.jpg",
    "wikipediaTitle": "Arlette Laguiller",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Arlette_Laguiller",
    "wikidataId": "Q12942",
    "commonsFile": "Arlette Laguiller.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Arlette_Laguiller.jpg",
    "author": "Lutte Ouvrière",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-simone-veil": {
    "path": "/images/persons/person-simone-veil.jpg",
    "wikipediaTitle": "Simone Veil",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Simone_Veil",
    "wikidataId": "Q298180",
    "commonsFile": "Simone Veil, gymnase Japy 2008 02 27 n3 ret.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Simone_Veil,_gymnase_Japy_2008_02_27_n3_ret.jpg",
    "author": "Marie-Lan Nguyen (User:Jastrow)",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0",
    "retrievedAt": "2026-08-26"
  },
  "person-gisele-halimi": {
    "path": "/images/persons/person-gisele-halimi.jpg",
    "wikipediaTitle": "Gisèle Halimi",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Gis%C3%A8le_Halimi",
    "wikidataId": "Q457705",
    "commonsFile": "Gisele Halimi - Huma-2008 2.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Gisele_Halimi_-_Huma-2008_2.jpg",
    "author": "Olivier « toutoune25 » Tétard",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "retrievedAt": "2026-08-26"
  },
  "person-simone-de-beauvoir": {
    "path": "/images/persons/person-simone-de-beauvoir.png",
    "wikipediaTitle": "Simone de Beauvoir",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Simone_de_Beauvoir",
    "wikidataId": "Q7197",
    "commonsFile": "Simone de Beauvoir2.png",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Simone_de_Beauvoir2.png",
    "author": "Moshe Milner",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "retrievedAt": "2026-08-26"
  },
  "person-olivier-rolin": {
    "path": "/images/persons/person-olivier-rolin.jpg",
    "wikipediaTitle": "Olivier Rolin",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Olivier_Rolin",
    "wikidataId": "Q1238602",
    "commonsFile": "Olivier Rolin.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Olivier_Rolin.jpg",
    "author": "This video, screenshot or audio excerpt was released under the Creative Commons license option on YouTube before August 2025. (YouTube changed the license version from CC BY 3.0 to 4.0 on August 1; this was not retroactive.) For videos uploaded or licensed after July 2025 use {{YouTube CC-BY 4.0}} To the uploader: You must provide a link (URL) to the original file and the authorship information if available. , This file is licensed under the Creative Commons Attribution 3.0 Unported license.Attribution: librairie mollat You are free: to share – to copy, distribute and transmit the work to remix – to adapt the work Under the following conditions: attribution – You must give appropriate credit, provide a link to the license, and indicate if changes were made. You may do so in any reasonable manner, but not in any way that suggests the licensor endorses you or your use. https://creativecommons.org/licenses/by/3.0CC BY 3.0 Creative Commons Attribution 3.0 truetrue",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0",
    "retrievedAt": "2026-08-26"
  },
  "person-jean-royer": {
    "path": "/images/persons/person-jean-royer.jpg",
    "wikipediaTitle": "Jean Royer (homme politique)",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Jean_Royer_(homme_politique)",
    "wikidataId": "Q1685804",
    "commonsFile": "1974-04-25 Meeting Jean Royer à Toulouse (1974) - 53Fi5660 (cropped).jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:1974-04-25_Meeting_Jean_Royer_%C3%A0_Toulouse_(1974)_-_53Fi5660_(cropped).jpg",
    "author": "André Cros",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "retrievedAt": "2026-08-26"
  },
  "person-daniel-gluckstein": {
    "path": "/images/persons/person-daniel-gluckstein.jpg",
    "wikipediaTitle": "Daniel Gluckstein",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Daniel_Gluckstein",
    "wikidataId": "Q926836",
    "commonsFile": "Daniel Gluckstein en 2002 a Lyon.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Daniel_Gluckstein_en_2002_a_Lyon.jpg",
    "author": "Tusco",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "retrievedAt": "2026-08-26"
  },
  "person-brice-lalonde": {
    "path": "/images/persons/person-brice-lalonde.jpg",
    "wikipediaTitle": "Brice Lalonde",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Brice_Lalonde",
    "wikidataId": "Q2512092",
    "commonsFile": "Brice Lalonde, 2014 (cropped).jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Brice_Lalonde,_2014_(cropped).jpg",
    "author": "Thomas Bresson",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0",
    "retrievedAt": "2026-08-26"
  },
  "person-noel-mamere": {
    "path": "/images/persons/person-noel-mamere.jpg",
    "wikipediaTitle": "Noël Mamère",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/No%C3%ABl_Mam%C3%A8re",
    "wikidataId": "Q965109",
    "commonsFile": "Noel.Mamere2006.JPG",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Noel.Mamere2006.JPG",
    "author": "Kenji-Baptiste OIKAWA",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0",
    "retrievedAt": "2026-08-26"
  },
  "person-antoine-waechter": {
    "path": "/images/persons/person-antoine-waechter.jpg",
    "wikipediaTitle": "Antoine Waechter",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Antoine_Waechter",
    "wikidataId": "Q2856831",
    "commonsFile": "Antoine Waechter, 2009 (cropped).jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Antoine_Waechter,_2009_(cropped).jpg",
    "author": "WAECHTER Antoine",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "retrievedAt": "2026-08-26"
  },
  "person-pierre-mauroy": {
    "path": "/images/persons/person-pierre-mauroy.jpg",
    "wikipediaTitle": "Pierre Mauroy",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Pierre_Mauroy",
    "wikidataId": "Q156511",
    "commonsFile": "Pierre Mauroy 1990.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Pierre_Mauroy_1990.jpg",
    "author": "Peer Grimm",
    "license": "CC BY-SA 3.0 de",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/de/deed.en",
    "retrievedAt": "2026-08-26"
  },
  "person-andre-lajoinie": {
    "path": "/images/persons/person-andre-lajoinie.jpg",
    "wikipediaTitle": "André Lajoinie",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Andr%C3%A9_Lajoinie",
    "wikidataId": "Q520481",
    "commonsFile": "Andre Lajoinie 1988 Photogrphie Olivier Victor Marius DUMAY.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Andre_Lajoinie_1988_Photogrphie_Olivier_Victor_Marius_DUMAY.jpg",
    "author": "Olivier Victor Marius DUMAY",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "retrievedAt": "2026-08-26"
  },
  "person-jean-pierre-chevenement": {
    "path": "/images/persons/person-jean-pierre-chevenement.jpg",
    "wikipediaTitle": "Jean-Pierre Chevènement",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Jean-Pierre_Chev%C3%A8nement",
    "wikidataId": "Q736502",
    "commonsFile": "2014-07-14 11-07-47 defile-militaire-belfort (cropped).jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:2014-07-14_11-07-47_defile-militaire-belfort_(cropped).jpg",
    "author": "Thomas Bresson",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0",
    "retrievedAt": "2026-08-26"
  },
  "person-marie-noelle-lienemann": {
    "path": "/images/persons/person-marie-noelle-lienemann.jpg",
    "wikipediaTitle": "Marie-Noëlle Lienemann",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Marie-No%C3%ABlle_Lienemann",
    "wikidataId": "Q461454",
    "commonsFile": "Marie-Noëlle Lienemann.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Marie-No%C3%ABlle_Lienemann.jpg",
    "author": "European Union - Source : EP",
    "license": "Attribution",
    "retrievedAt": "2026-08-26"
  },
  "person-francois-bayrou": {
    "path": "/images/persons/person-francois-bayrou.jpg",
    "wikipediaTitle": "François Bayrou",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Fran%C3%A7ois_Bayrou",
    "wikidataId": "Q12963",
    "commonsFile": "Bayrou Matignon (cropped).jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Bayrou_Matignon_(cropped).jpg",
    "author": "Service photographique de Matignon",
    "license": "Licence Ouverte",
    "licenseUrl": "https://www.etalab.gouv.fr/licence-ouverte-open-licence",
    "retrievedAt": "2026-08-26"
  },
  "person-alain-madelin": {
    "path": "/images/persons/person-alain-madelin.jpg",
    "wikipediaTitle": "Alain Madelin",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Alain_Madelin",
    "wikidataId": "Q582101",
    "commonsFile": "Alain Madelin 2009.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Alain_Madelin_2009.jpg",
    "author": "State Chancellery of Latvia",
    "license": "CC BY-SA 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/2.0",
    "retrievedAt": "2026-08-26"
  },
  "person-charles-pasqua": {
    "path": "/images/persons/person-charles-pasqua.jpg",
    "wikipediaTitle": "Charles Pasqua",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Charles_Pasqua",
    "wikidataId": "Q725609",
    "commonsFile": "Charles Pasqua.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Charles_Pasqua.jpg",
    "author": "Engelbert Reineke",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "retrievedAt": "2026-08-26"
  },
  "person-philippe-de-villiers": {
    "path": "/images/persons/person-philippe-de-villiers.jpg",
    "wikipediaTitle": "Philippe de Villiers",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Philippe_de_Villiers",
    "wikidataId": "Q704846",
    "commonsFile": "Philippe de Villiers - Meeting in Toulouse for the 2007 French presidential election 0165 2007-04-16 cropped.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Philippe_de_Villiers_-_Meeting_in_Toulouse_for_the_2007_French_presidential_election_0165_2007-04-16_cropped.jpg",
    "author": "Guillaume Paumier",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "http://creativecommons.org/licenses/by-sa/3.0/",
    "retrievedAt": "2026-08-26"
  },
  "person-jean-saint-josse": {
    "path": "/images/persons/person-jean-saint-josse.jpg",
    "wikipediaTitle": "Jean Saint-Josse",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Jean_Saint-Josse",
    "wikidataId": "Q3174521",
    "commonsFile": "Jean Saint-Josse.JPG",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Jean_Saint-Josse.JPG",
    "author": "Cheep975",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "retrievedAt": "2026-08-26"
  },
  "person-bruno-megret": {
    "path": "/images/persons/person-bruno-megret.jpg",
    "wikipediaTitle": "Bruno Mégret",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Bruno_M%C3%A9gret",
    "wikidataId": "Q993611",
    "commonsFile": "Bruno Megret 482555538 17cb7bbe60 o.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Bruno_Megret_482555538_17cb7bbe60_o.jpg",
    "author": "François Lafite from Paris, FRANCE",
    "license": "CC BY 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/2.0",
    "retrievedAt": "2026-08-26"
  },
  "person-edouard-balladur": {
    "path": "/images/persons/person-edouard-balladur.jpg",
    "wikipediaTitle": "Édouard Balladur",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/%C3%89douard_Balladur",
    "wikidataId": "Q12959",
    "commonsFile": "Édouard Balladur - 1993 (cropped).jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:%C3%89douard_Balladur_-_1993_(cropped).jpg",
    "author": "European Communities, 1993 / EC - Audiovisual Service",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0",
    "retrievedAt": "2026-08-26"
  },
  "person-alain-juppe": {
    "path": "/images/persons/person-alain-juppe.jpg",
    "wikipediaTitle": "Alain Juppé",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Alain_Jupp%C3%A9",
    "wikidataId": "Q215569",
    "commonsFile": "Alain Juppé à Québec en 2015 (cropped 2).jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Alain_Jupp%C3%A9_%C3%A0_Qu%C3%A9bec_en_2015_(cropped_2).jpg",
    "author": "Florencecassisi",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0",
    "retrievedAt": "2026-08-26"
  },
  "person-robert-hue": {
    "path": "/images/persons/person-robert-hue.jpg",
    "wikipediaTitle": "Robert Hue",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Robert_Hue",
    "wikidataId": "Q937091",
    "commonsFile": "Robert Hue 09796.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Robert_Hue_09796.jpg",
    "author": "G.Garitan",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "retrievedAt": "2026-08-26"
  },
  "person-marie-george-buffet": {
    "path": "/images/persons/person-marie-george-buffet.jpg",
    "wikipediaTitle": "Marie-George Buffet",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Marie-George_Buffet",
    "wikidataId": "Q464029",
    "commonsFile": "Marie-George Buffet en 2012.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Marie-George_Buffet_en_2012.jpg",
    "author": "Nico9393",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "retrievedAt": "2026-08-26"
  },
  "person-dominique-voynet": {
    "path": "/images/persons/person-dominique-voynet.jpg",
    "wikipediaTitle": "Dominique Voynet",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Dominique_Voynet",
    "wikidataId": "Q268669",
    "commonsFile": "Dominique Voynet - Anti-EPR demonstration in Toulouse 0025 2007-03-17 cropped.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Dominique_Voynet_-_Anti-EPR_demonstration_in_Toulouse_0025_2007-03-17_cropped.jpg",
    "author": "Guillaume Paumier",
    "license": "CC BY-SA 2.5",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/2.5",
    "retrievedAt": "2026-08-26"
  },
  "person-olivier-besancenot": {
    "path": "/images/persons/person-olivier-besancenot.jpg",
    "wikipediaTitle": "Olivier Besancenot",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Olivier_Besancenot",
    "wikidataId": "Q12932",
    "commonsFile": "Meeting NPA - Toulouse - 2012-04-17 - 21h25 (cropped).jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Meeting_NPA_-_Toulouse_-_2012-04-17_-_21h25_(cropped).jpg",
    "author": "Pierre-Selim",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0",
    "retrievedAt": "2026-08-26"
  },
  "person-jean-luc-melenchon": {
    "path": "/images/persons/person-jean-luc-melenchon.jpg",
    "wikipediaTitle": "Jean-Luc Mélenchon",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Jean-Luc_M%C3%A9lenchon",
    "wikidataId": "Q5829",
    "commonsFile": "Mélenchon 2027 - 55261894422 (cropped).jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:M%C3%A9lenchon_2027_-_55261894422_(cropped).jpg",
    "author": "jlm2017.fr",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0",
    "retrievedAt": "2026-08-26"
  },
  "person-nicolas-sarkozy": {
    "path": "/images/persons/person-nicolas-sarkozy.jpg",
    "wikipediaTitle": "Nicolas Sarkozy",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Nicolas_Sarkozy",
    "wikidataId": "Q329",
    "commonsFile": "Nicolas Sarkozy in 2010.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Nicolas_Sarkozy_in_2010.jpg",
    "author": "European People's Party",
    "license": "CC BY 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/2.0",
    "retrievedAt": "2026-08-26"
  },
  "person-segolene-royal": {
    "path": "/images/persons/person-segolene-royal.jpg",
    "wikipediaTitle": "Ségolène Royal",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/S%C3%A9gol%C3%A8ne_Royal",
    "wikidataId": "Q81923",
    "commonsFile": "Segolene Royal Arcueil 18 septembre 2010 6.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Segolene_Royal_Arcueil_18_septembre_2010_6.jpg",
    "author": "Thestreamer",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "retrievedAt": "2026-08-26"
  },
  "person-cecile-duflot": {
    "path": "/images/persons/person-cecile-duflot.jpg",
    "wikipediaTitle": "Cécile Duflot",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/C%C3%A9cile_Duflot",
    "wikidataId": "Q268634",
    "commonsFile": "Cécile Duflot, 2010 (cropped).jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:C%C3%A9cile_Duflot,_2010_(cropped).jpg",
    "author": "Marie-Lan Nguyen",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0",
    "retrievedAt": "2026-08-26"
  },
  "person-yannick-jadot": {
    "path": "/images/persons/person-yannick-jadot.jpg",
    "wikipediaTitle": "Yannick Jadot",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Yannick_Jadot",
    "wikidataId": "Q441791",
    "commonsFile": "Member of the European Parliament Yannick Jadot.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Member_of_the_European_Parliament_Yannick_Jadot.jpg",
    "author": "© European Union, 1998 – 2026",
    "license": "Attribution",
    "retrievedAt": "2026-08-26"
  },
  "person-corinne-lepage": {
    "path": "/images/persons/person-corinne-lepage.jpg",
    "wikipediaTitle": "Corinne Lepage",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Corinne_Lepage",
    "wikidataId": "Q291341",
    "commonsFile": "Lepage, Corinne-2493.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Lepage,_Corinne-2493.jpg",
    "author": "Foto-AG Gymnasium Melle",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "retrievedAt": "2026-08-26"
  },
  "person-francois-fillon": {
    "path": "/images/persons/person-francois-fillon.jpg",
    "wikipediaTitle": "François Fillon",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Fran%C3%A7ois_Fillon",
    "wikidataId": "Q101410",
    "commonsFile": "François Fillon 2010.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Fran%C3%A7ois_Fillon_2010.jpg",
    "author": "Marie-Lan Nguyen",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0",
    "retrievedAt": "2026-08-26"
  },
  "person-jean-pierre-raffarin": {
    "path": "/images/persons/person-jean-pierre-raffarin.jpg",
    "wikipediaTitle": "Jean-Pierre Raffarin",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Jean-Pierre_Raffarin",
    "wikidataId": "Q63263",
    "commonsFile": "Jean-Pierre Raffarin par Claude Truong-Ngoc 2013 (cropped).jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Jean-Pierre_Raffarin_par_Claude_Truong-Ngoc_2013_(cropped).jpg",
    "author": "Claude TRUONG-NGOC",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "retrievedAt": "2026-08-26"
  },
  "person-dominique-villepin": {
    "path": "/images/persons/person-dominique-villepin.jpg",
    "wikipediaTitle": "Dominique de Villepin",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Dominique_de_Villepin",
    "wikidataId": "Q131660",
    "commonsFile": "Dominique de Villepin (2010).jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Dominique_de_Villepin_(2010).jpg",
    "author": "Georges Seguin (Okki)",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "retrievedAt": "2026-08-26"
  },
  "person-manon-aubry": {
    "path": "/images/persons/person-manon-aubry.jpg",
    "wikipediaTitle": "Manon Aubry",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Manon_Aubry",
    "wikidataId": "Q59601214",
    "commonsFile": "Manon Aubry , SOTEU 2022 (52359513224) (cropped).jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Manon_Aubry_,_SOTEU_2022_(52359513224)_(cropped).jpg",
    "author": "European Parliament from EU",
    "license": "CC BY 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/2.0",
    "retrievedAt": "2026-08-26"
  },
  "person-alexis-corbiere": {
    "path": "/images/persons/person-alexis-corbiere.jpg",
    "wikipediaTitle": "Alexis Corbière",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Alexis_Corbi%C3%A8re",
    "wikidataId": "Q2834481",
    "commonsFile": "Alexis Corbière Jardin 4colonnes (cropped).jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Alexis_Corbi%C3%A8re_Jardin_4colonnes_(cropped).jpg",
    "author": "Jean-Luc Hauser",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "retrievedAt": "2026-08-26"
  },
  "person-clementine-autain": {
    "path": "/images/persons/person-clementine-autain.jpg",
    "wikipediaTitle": "Clémentine Autain",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Cl%C3%A9mentine_Autain",
    "wikidataId": "Q2980738",
    "commonsFile": "Clementine-Autain.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Clementine-Autain.jpg",
    "author": "Io",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "retrievedAt": "2026-08-26"
  },
  "person-emmanuel-macron": {
    "path": "/images/persons/person-emmanuel-macron.jpg",
    "wikipediaTitle": "Emmanuel Macron",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Emmanuel_Macron",
    "wikidataId": "Q3052772",
    "commonsFile": "Emmanuel Macron 2025 (cropped).jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Emmanuel_Macron_2025_(cropped).jpg",
    "author": "Nebojša Tejić",
    "license": "Public domain",
    "retrievedAt": "2026-08-26"
  },
  "person-edouard-philippe": {
    "path": "/images/persons/person-edouard-philippe.jpg",
    "wikipediaTitle": "Édouard Philippe",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/%C3%89douard_Philippe",
    "wikidataId": "Q3579995",
    "commonsFile": "Édouard Philippe 2019 (cropped).jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:%C3%89douard_Philippe_2019_(cropped).jpg",
    "author": "Jacques Paquier",
    "license": "CC BY 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/2.0",
    "retrievedAt": "2026-08-26"
  },
  "person-christophe-castaner": {
    "path": "/images/persons/person-christophe-castaner.jpg",
    "wikipediaTitle": "Christophe Castaner",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Christophe_Castaner",
    "wikidataId": "Q1726930",
    "commonsFile": "Christophe Castaner en 2019 (cropped 2).jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Christophe_Castaner_en_2019_(cropped_2).jpg",
    "author": "Arthur Empereur",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "retrievedAt": "2026-08-26"
  },
  "person-nicolas-dupont-aignan": {
    "path": "/images/persons/person-nicolas-dupont-aignan.jpg",
    "wikipediaTitle": "Nicolas Dupont-Aignan",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Nicolas_Dupont-Aignan",
    "wikidataId": "Q12961",
    "commonsFile": "Nicolas Dupont-Aignan, homme politique français.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Nicolas_Dupont-Aignan,_homme_politique_fran%C3%A7ais.jpg",
    "author": "Debout la France",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "retrievedAt": "2026-08-26"
  },
  "person-francois-asselineau": {
    "path": "/images/persons/person-francois-asselineau.jpg",
    "wikipediaTitle": "François Asselineau",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Fran%C3%A7ois_Asselineau",
    "wikidataId": "Q12972",
    "commonsFile": "François ASSELINEAU.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Fran%C3%A7ois_ASSELINEAU.jpg",
    "author": "Union Populaire Républicaine",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "retrievedAt": "2026-08-26"
  },
  "person-marine-le-pen": {
    "path": "/images/persons/person-marine-le-pen.jpg",
    "wikipediaTitle": "Marine Le Pen",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Marine_Le_Pen",
    "wikidataId": "Q12927",
    "commonsFile": "Marine Le Pen 2025 (cropped).jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Marine_Le_Pen_2025_(cropped).jpg",
    "author": "Vox España",
    "license": "CC0",
    "licenseUrl": "http://creativecommons.org/publicdomain/zero/1.0/deed.en",
    "retrievedAt": "2026-08-26"
  },
  "person-eric-zemmour": {
    "path": "/images/persons/person-eric-zemmour.jpg",
    "wikipediaTitle": "Éric Zemmour",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/%C3%89ric_Zemmour",
    "wikidataId": "Q288477",
    "commonsFile": "Portrait d'Éric Zemmour, avril 2022.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Portrait_d%27%C3%89ric_Zemmour,_avril_2022.jpg",
    "author": "Anh De France",
    "license": "CC0",
    "licenseUrl": "http://creativecommons.org/publicdomain/zero/1.0/deed.en",
    "retrievedAt": "2026-08-26"
  },
  "person-francois-hollande": {
    "path": "/images/persons/person-francois-hollande.jpg",
    "wikipediaTitle": "François Hollande",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Fran%C3%A7ois_Hollande",
    "wikidataId": "Q157",
    "commonsFile": "François Hollande - 2017 (27869823159) (cropped 2).jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Fran%C3%A7ois_Hollande_-_2017_(27869823159)_(cropped_2).jpg",
    "author": "Web Summit",
    "license": "CC BY 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/2.0",
    "retrievedAt": "2026-08-26"
  },
  "person-eva-joly": {
    "path": "/images/persons/person-eva-joly.jpg",
    "wikipediaTitle": "Eva Joly",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Eva_Joly",
    "wikidataId": "Q464116",
    "commonsFile": "Eva Joly par Claude Truong-Ngoc juin 2013.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Eva_Joly_par_Claude_Truong-Ngoc_juin_2013.jpg",
    "author": "Photo Claude TRUONG-NGOC",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "retrievedAt": "2026-08-26"
  },
  "person-benoit-hamon": {
    "path": "/images/persons/person-benoit-hamon.jpg",
    "wikipediaTitle": "Benoît Hamon",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Beno%C3%AEt_Hamon",
    "wikidataId": "Q818118",
    "commonsFile": "Benoit Hamon 280816.jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Benoit_Hamon_280816.jpg",
    "author": "Marion Germa",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "retrievedAt": "2026-08-26"
  },
  "person-helene-thouy": {
    "path": "/images/persons/person-helene-thouy.jpg",
    "wikipediaTitle": "Hélène Thouy",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/H%C3%A9l%C3%A8ne_Thouy",
    "wikidataId": "Q63646237",
    "commonsFile": "Helene Thouy (cropped).jpg",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Helene_Thouy_(cropped).jpg",
    "author": "Jonathan Lecarderonnel",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "retrievedAt": "2026-08-26"
  },
  "person-philippe-poutou": {
    "path": "/images/persons/person-philippe-poutou.png",
    "wikipediaTitle": "Philippe Poutou",
    "wikipediaUrl": "https://fr.wikipedia.org/wiki/Philippe_Poutou",
    "wikidataId": "Q2631198",
    "commonsFile": "Philippe Poutou 2020 (cropped).png",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File:Philippe_Poutou_2020_(cropped).png",
    "author": "Patrice CALATAYU from Bordeaux, France",
    "license": "CC BY-SA 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/2.0",
    "retrievedAt": "2026-08-26"
  }
};
